<template>
  <v-container fill-height fluid grid-list-xl>
    <v-row>
      <v-col>
        <material-card color="green" flat full-width title="Новый заказ">
          <v-simple-table>
            <template #default>
              <tbody>
                <tr>
                  <td> Имя </td>
                  <td><v-text-field v-model="data.customerName" /></td>
                </tr>
                <tr>
                  <td> Email </td>
                  <td><v-text-field v-model="data.customerEmail" /></td>
                </tr>
                <tr>
                  <td> Телефон </td>
                  <td><v-text-field v-model="data.customerPhone" /></td>
                </tr>
                <tr>
                  <td> Доставка </td>
                  <td><v-select
                    v-model="data.deliveryId"
                    :items="getDeliveriesList()"
                    @change="selectNewDelivery()"
                  /></td>
                </tr>
                <tr>
                  <td> Оплата </td>
                  <td><v-select
                    v-model="data.paymentId"
                    :items="getPaymentsList()"
                    @change="selectNewPayment()"
                  /></td>
                </tr>
                <tr>
                  <td> Промокод </td>
                  <td><v-text-field v-model="data.extraFields.promoCode" /></td>
                </tr>
                <tr>
                  <td> Адрес </td>
                  <td><v-text-field v-model="data.deliveryInfo.address" /></td>
                </tr>
                <tr>
                  <td> Комментарий к заказу</td>
                  <td><v-text-field v-model="data.customerComment" /></td>
                </tr>
                <tr>
                  <td>Коментарий менеджера</td>
                  <td><v-text-field v-model="data.managerComment" /></td>
                </tr>
                <tr>
                  <td>  Сумма заказа </td>
                  <td>{{ getOrderSum() }}</td>
                </tr>
                <tr>
                  <td> Скидка к заказу </td>
                  <td>{{ getOrderDiscount() }}%</td>
                </tr>
                <tr>
                  <td> Сумма с учетом скидки</td>
                  <td> <v-text-field v-model="data.sumTotal" /></td>
                </tr>
                <tr>
                  <td> Статус</td>
                  <td>
                    <v-select
                      v-model="data.status"
                      :items="statusList"
                    />
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </material-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <material-card color="green" flat full-width title="Товары в заказе">
          <v-data-table
            :headers="headersProduct"
            :items="data.items"
            :loading="loadingProducts"
            class="elevation-1"
            hide-default-footer
          >
            <template #item.image="{ item }">
              <v-img
                width="50px"
                height="50px"
                :src="`${getImage(item)}`"
              />
            </template>
            <template #item.name="{ item }">
              {{ item.name }}
            </template>
            <template #item.discount="{ item }">
              {{ getDiscount(item) }}%
            </template>
            <template #item.quantity="{ item }">
              <v-text-field v-model="item.quantity" type="number" @change="recalc" />
            </template>
            <template #item.action="{ index }">
              <v-icon small class="mr-2" @click="delProduct(index)">
                mdi-bucket
              </v-icon>
            </template>
          </v-data-table>
          <select-c @selected="addItem" />
          <v-btn color="blue darken-1" text @click="addOffers">
            Добавить
          </v-btn>
        </material-card>
      </v-col>
    </v-row>
    <v-btn color="blue" @click="save">
      СОХРАНИТЬ!
    </v-btn>
  </v-container>
</template>

<script>
import { createOrder } from '@/graphql/orders'
import { calculateCartDiscount } from '@/graphql/discounter'
import { getDeliveries } from '@/graphql/deliveries'
import SelectC from '@/components/offers/select'
import { getPayments } from '@/graphql/payments'
import orderMixin from '@/helpers/orders'
export default {
  name: 'ViewOrder',
  components: {
    SelectC
  },
  mixins: [orderMixin],
  layout: 'dashboard',
  apollo: {
    Deliveries: {
      query: getDeliveries,
      result ({
                data,
                loading
              }) {
        if (data?.deliveries?.data) {
          this.deliveries = data.deliveries.data
        }
      },
      variables () {
        return {
          filter: {
            status: 'ACTIVE'
          }
        }
      }
    },
    Payments: {
      query: getPayments,
      result ({
                data,
                loading
              }) {
        if (data?.payments?.data) {
          this.payments = data.payments.data
        }
      },
      variables () {
        return {
          filter: {
            status: 'ACTIVE'
          }
        }
      }
    }
  },
  data () {
    return {
      edited: false,
      loadingProducts: false,
      itemsAdded: [],
      selectedItem: {},
      deliveries: {},
      payments: {},
      data: {
        customerName: '',
        customerPhone: '',
        customerEmail: '',
        customerComment: '',
        managerComment: '',
        deliveryId: 0,
        deliveryName: '',
        deliveryPrice: 0,
        deliveryInfo: {
          address: '',
          date: '',
          time: '',
          trackNumber: ''
        },
        paymentId: 0,
        paymentName: '',
        sumTotal: 0,
        currencyCode: 'RUB',
        type: 'REGULAR',
        status: 'NEW',
        extraFields: {
          promoCode: '',
          chequeDestination: 'EMAIL'
        },
        items: []
      },
      cartid: this.data?.cart?.id,
      statusList: [
        { value: 'NEW', text: 'Новый' },
        { value: 'IN_PROCESS', text: 'В процессе' },
        { value: 'IN_DELIVERY', text: 'На доставке' },
        { value: 'PAYMENT_PROGRESS', text: 'На оплате' },
        { value: 'PAYMENT_ACCEPTED', text: 'Оплата одобрена' },
        { value: 'PAYMENT_FINISHED', text: 'Оплачен' },
        { value: 'DELETED', text: 'Удален' },
        { value: 'SENT', text: 'Отправлен' },
        { value: 'RETURN', text: 'Возвращен' }
      ],
      headersProduct: [
        {
          text: 'Id',
          value: 'offerId'
        },
        {
          text: 'Photo',
          value: 'image'
        },
        {
          text: 'Name',
          value: 'name'
        },
        {
          text: 'Цена',
          value: 'price'
        },
        {
          text: 'Кол-во',
          value: 'quantity'
        },
        {
          text: 'Скидка',
          value: 'discount'
        },
        {
          text: 'Сумма',
          value: 'sumTotal'
        },
        {
          text: '#',
          value: 'action'
        }
      ]
    }
  },
  methods: {
    getOrderDiscount () {
      const oneP = this.getOrderSum() / 100
      const pp = this.data?.sumTotal / oneP
      return Math.round(100 - pp)
    },
    getOrderSum () {
      let summ = 0
      this.data?.items?.forEach((item) => {
        summ = summ + parseFloat(item.price)
      })
      return summ
    },
    getDiscount (item) {
      const oneP = (item.price * item.quantity) / 100
      const pp = item.sumTotal / oneP
      return Math.round(100 - pp)
    },
    getImage (item) {
      return item.images?.[0].file?.url
    },
    addItem (val) {
      this.itemsAdded = val
    },
    addOffers () {
      this.itemsAdded.forEach((item) => {
        if (item.id) {
          const fil = this.data.items.filter(i => i.id === item.id)
          if (fil.length > 0) {
            fil[0].quantity = fil[0].quantity + 1
          } else {
            this.data.items.push({
              id: item.id,
              offerId: item.id,
              name: item.name,
              price: item.price,
              quantity: 1,
              sumTotal: item.price
            })
          }
        }
      })
      this.recalc()
    },
    recalc () {
      this.loadingProducts = true
      const offers = []
      this.data.items.forEach((item) => {
        let cats = []
        if (item.offer?.category) {
          cats = item.offer?.category?.map((i) => {
            return {
              id: String(i),
              isPartnerCategory: false
            }
          })
        }
        if (item.offer?.category_id > 0) {
          cats.push({
            id: String(item.offer?.category_id),
            isPartnerCategory: false
          })
        }
        const pearlType = item?.offer?.params?.find(param => param?.slug === 'pearlType')?.value || null
        const pearlColor = item?.offer?.params?.find(param => param?.slug === 'color')?.value
        const pearlDoubleColor = item?.offer?.params?.find(param => param?.slug === 'doublecolor')?.value
        offers.push({
          id: String(item?.offerId),
          price: item.price,
          oldPrice: item.oldPrice,
          quantity: parseInt(item.quantity),
          categories: cats,
          pearlType,
          pearlColor: (pearlColor && pearlColor !== '-1') ? pearlColor : pearlDoubleColor
        })
      })

      const input = {
        offers,
        promoCode: this.data.extraFields.promoCode,
        certificatesTotalSum: 0,
        usersOrderTotalSum: 0
      }
      this.$apollo
          .mutate({
            mutation: calculateCartDiscount,
            variables: { input }
          })
          .then((data) => {
            const rez = data?.data?.calculateCartDiscount
            if (rez?.totalSum) {
              this.data.sumTotal = rez?.totalSum
            }
            rez?.offers?.forEach((item, index) => {
              this.data.items[index].sumTotal = item.totalSum
            })
            this.loadingProducts = false
          })
          .catch((error) => {
            console.error(error)
          })
    },
    delProduct (index) {
      delete this.data.items.splice(index, 1)
      this.recalc()
    },
    save () {
      const data = Object.assign({}, this.data)
      data.items?.forEach((item) => {
        delete item.id
        delete item.offer
        delete item.__typename
        item.quantity = parseInt(item.quantity)
      })
      data.sumTotal = parseFloat(data.sumTotal)
      this.$apollo
          .mutate({
            mutation: createOrder,
            variables: {
              input: data
            }
          })
          .then((data) => {
            if (data?.data?.createOrder?.id) {
              this.$router.push('/orders/view/' + data.data.createOrder.id)
            }
          })
          .catch((error) => {
            console.error(error)
          })
    },
    getDeliveriesList () {
      return this?.deliveries.length > 0 ? this?.deliveries?.map(item => ({ text: this.getFullDeliveryName(item.name, item.group_name), value: item.id })) : []
    },
    getPaymentsList () {
      return this?.payments.length > 0 ? this?.payments?.map(item => ({ text: item.name, value: item.id })) : []
    },
    getFullDeliveryName (name, groupName) {
      return name + ' (' + groupName + ')'
    },
    selectNewDelivery () {
      const selectedDelivery = this?.deliveries?.filter(item => item.id === this.data.deliveryId)[0]
      if (selectedDelivery) {
        this.data.deliveryName = this.getFullDeliveryName(selectedDelivery.name, selectedDelivery.group_name)
        this.data.deliveryPrice = selectedDelivery.sum ?? 0
      }
    },
    selectNewPayment () {
      this.data.paymentName = this?.payments?.filter(item => item.id === this.data.paymentId)[0]?.name
    }
  }
}
</script>
